import React from 'react';
import { useSelector } from 'react-redux';

import {
  getCampsiteCampgroundSiteMapUrl,
  getLocation,
  getStayLocationDescription,
  getVehicleType,
} from '@/redux/selectors/listing/location';
import { TVehicleType } from '@/services/types/search/rentals/id';

import Location from './Location';

export const mapVehicleTypeToPin: Record<TVehicleType, string> = {
  'camper-van': 'campervan',
  a: 'class_a',
  b: 'class_b',
  c: 'class_c',
  'fifth-wheel': 'fifth-wheel',
  'folding-trailer': 'folding-trailer',
  other: 'other',
  'toy-hauler': 'toy-hauler',
  'tow-vehicle': 'trailer',
  trailer: 'trailer',
  'truck-camper': 'truck-camper',
  'utility-trailer': 'utility-trailer',
};
interface ILocationContainerProps {
  isCampsite?: boolean;
}

const LocationContainer: React.FC<ILocationContainerProps> = ({ isCampsite }) => {
  const location = useSelector(getLocation);

  const vehicleType = useSelector(getVehicleType);
  const stayLocationDescription = useSelector(getStayLocationDescription);
  const siteMapUrl = useSelector(getCampsiteCampgroundSiteMapUrl);

  if (!location) {
    return null;
  }

  return (
    <Location
      listingLocation={location}
      stayLocationDescription={stayLocationDescription}
      lat={location.lat}
      lon={location.lng}
      pin={`https://d1o5877uy6tsnd.cloudfront.net/img/location-map-pins/${(() => {
        if (isCampsite) return 'campground';

        return `map-pin-${
          (vehicleType && mapVehicleTypeToPin[vehicleType]) || mapVehicleTypeToPin.c
        }-v2`;
      })()}.png`}
      siteMapUrl={siteMapUrl}
    />
  );
};

export default LocationContainer;
